Namespace 'Common.Sessions'

class Common.ResizeButton extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/resize_button']

  initialize: ({onClick, rectangularLayout = false}) ->
    @onClick = onClick
    @rectangularLayout = rectangularLayout

  render: =>
    @$el.html(@template())
    @$('.filters-resize').click @onClick
    @_enableRectangularLayout() if @rectangularLayout
    @

  _enableRectangularLayout: ->
    @$('.filters-resize').addClass('rectangularLayout')
